/* ============================================================
   MANSIÓN MONARA — CONCEPTO 4 — JAVASCRIPT
   Shopify Template | Claude Version
   ============================================================ */

'use strict';

window.MMC4 = window.MMC4 || {};

/* ── Helpers ───────────────────────────────── */
/* Para valores en centavos: /products/{handle}.js, cart.js, o el product|json de Liquid */
MMC4.formatMoney = (cents) => {
  const n = parseFloat(cents);
  if (isNaN(n) || cents == null) return '';
  return '$' + (n / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ' MXN';
};

/* Para valores ya en pesos: /collections/{handle}/products.json, /products.json */
MMC4.formatMoneyFromPesos = (pesos) => {
  const n = parseFloat(pesos);
  if (isNaN(n) || pesos == null) return '';
  return '$' + n.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ' MXN';
};

/* ── Cart Drawer ──────────────────────────── */
MMC4.CartDrawer = {
  drawer:  null,
  overlay: null,

  init() {
    this.drawer  = document.querySelector('.c4-cart-drawer');
    this.overlay = document.querySelector('.c4-cart-overlay');
    if (!this.drawer) return;

    document.querySelectorAll('[data-c4-cart-open]').forEach(el =>
      el.addEventListener('click', () => this.open())
    );

    this.overlay?.addEventListener('click', () => this.close());
    this.drawer.querySelector('.c4-cart-drawer__close')
        ?.addEventListener('click', () => this.close());

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && this.drawer.classList.contains('is-open')) this.close();
    });
  },

  open() {
    this.drawer.classList.add('is-open');
    this.overlay?.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    this.fetchAndRender();
  },

  close() {
    this.drawer.classList.remove('is-open');
    this.overlay?.classList.remove('is-open');
    document.body.style.overflow = '';
  },

  async fetchAndRender() {
    try {
      const res  = await fetch('/cart.js');
      const cart = await res.json();
      this.render(cart);
    } catch (e) { console.error('Cart fetch:', e); }
  },

  render(cart) {
    const itemsEl   = this.drawer.querySelector('.c4-cart-drawer__items');
    const titleEl   = this.drawer.querySelector('.c4-cart-drawer__title');
    const totalEl   = this.drawer.querySelector('[data-c4-cart-total]');
    const countEls  = document.querySelectorAll('[data-c4-cart-count]');

    if (titleEl) titleEl.textContent = `Tu Carrito (${cart.item_count})`;
    if (totalEl) totalEl.textContent = MMC4.formatMoney(cart.total_price);
    countEls.forEach(el => {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });

    if (!itemsEl) return;

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<p style="text-align:center;padding:48px 0;color:var(--c4-on-surface-variant);font-style:italic;">Tu carrito está vacío.</p>';
      return;
    }

    itemsEl.innerHTML = cart.items.map(item => `
      <div class="c4-cart-item" data-line-key="${item.key}">
        <img class="c4-cart-item__img" src="${item.image}" alt="${item.product_title}">
        <div>
          <p class="c4-cart-item__brand">${item.vendor}</p>
          <p class="c4-cart-item__title">${item.product_title}</p>
          ${item.variant_title && item.variant_title !== 'Default Title'
            ? `<p class="c4-cart-item__variant">${item.variant_title}</p>` : ''}
          <p class="c4-cart-item__price">${MMC4.formatMoney(item.final_line_price)}</p>
          <div class="c4-cart-item__qty">
            <button class="c4-cart-item__qty-btn" data-qty-action="dec" data-key="${item.key}">−</button>
            <span class="c4-cart-item__qty-val">${item.quantity}</span>
            <button class="c4-cart-item__qty-btn" data-qty-action="inc" data-key="${item.key}">+</button>
          </div>
        </div>
        <button class="c4-cart-item__remove" data-key="${item.key}" aria-label="Eliminar">✕</button>
      </div>
    `).join('');

    itemsEl.querySelectorAll('[data-qty-action]').forEach(btn => {
      btn.addEventListener('click', () => {
        const key = btn.dataset.key;
        const row = btn.closest('.c4-cart-item');
        const val = parseInt(row?.querySelector('.c4-cart-item__qty-val')?.textContent || '1');
        this.changeQty(key, btn.dataset.qtyAction === 'inc' ? val + 1 : Math.max(0, val - 1));
      });
    });

    itemsEl.querySelectorAll('.c4-cart-item__remove').forEach(btn => {
      btn.addEventListener('click', () => this.changeQty(btn.dataset.key, 0));
    });
  },

  async changeQty(key, qty) {
    try {
      const res  = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty }),
      });
      const cart = await res.json();
      this.render(cart);
    } catch (e) { console.error('Cart change:', e); }
  },

  async addItem(variantId, qty = 1) {
    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty }),
      });
      this.open();
    } catch (e) { console.error('Cart add:', e); }
  },
};

/* ── Comprar ahora — agrega al carrito y va directo a checkout ──
   Usa el mismo mecanismo nativo que ya probamos confiable para
   "Proceder al pago" (form POST a /cart con name="checkout"), en vez
   de /checkout?variantId=... que solo funcionaba si el carrito ya
   traía algo de antes — con carrito vacío, Shopify rebota al
   referrer en lugar de ir a checkout. */
MMC4.buyNow = async (variantId, quantity = 1) => {
  try {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity }),
    });
  } catch (e) { console.error('Buy now add:', e); }

  const form = document.createElement('form');
  form.action = '/cart';
  form.method = 'post';
  form.style.display = 'none';
  const input = document.createElement('input');
  input.type = 'hidden';
  input.name = 'checkout';
  input.value = 'Checkout';
  form.appendChild(input);
  document.body.appendChild(form);
  form.submit();
};

/* ── Quick-Add Modal ───────────────────────── */
MMC4.QuickAdd = {
  modal: null,

  init() {
    this.modal = document.querySelector('#c4-quickadd-modal');
    if (!this.modal) return;

    document.addEventListener('click', async e => {
      const trigger = e.target.closest('[data-c4-quickadd]');
      if (!trigger) return;
      e.preventDefault();
      await this.load(trigger.dataset.c4Quickadd, trigger.dataset.sizeGuideImg, trigger.dataset.sizeGuideTitle);
    });

    this.modal.addEventListener('click', e => {
      if (e.target === this.modal) this.close();
    });
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') this.close();
    });
  },

  async load(handle, sizeGuideImg, sizeGuideTitle) {
    try {
      const res     = await fetch(`/products/${handle}.js`);
      const product = await res.json();
      this.render(product, sizeGuideImg, sizeGuideTitle);
      this.open();
    } catch (e) { console.error('QuickAdd load:', e); }
  },

  render(product, sizeGuideImg, sizeGuideTitle) {
    let selectedVariant = product.variants.find(v => v.available) || product.variants[0];

    const sizesHtml = product.variants.map(v => `
      <button class="c4-pdp__size-btn ${v.id === selectedVariant?.id ? 'is-active' : ''} ${!v.available ? 'is-soldout' : ''}"
              data-variant-id="${v.id}" ${!v.available ? 'disabled' : ''}>
        ${v.title === 'Default Title' ? 'Talla única' : v.title}
      </button>
    `).join('');

    this.modal.innerHTML = `
      <div class="c4-modal">
        <div class="c4-modal__header">
          <img class="c4-modal__img" src="${product.featured_image}" alt="">
          <div>
            <p class="c4-modal__brand">${product.vendor}</p>
            <p class="c4-modal__title">${product.title}</p>
            <p class="c4-modal__price">${MMC4.formatMoney(product.price)}</p>
          </div>
          <button class="c4-modal__close" aria-label="Cerrar">✕</button>
        </div>
        <div class="c4-modal__body">
          <div class="c4-modal__size-header">
            <span>Selecciona talla</span>
            ${sizeGuideImg ? `<button type="button" class="c4-modal__size-guide" data-size-guide-trigger data-size-guide-img="${sizeGuideImg}" data-size-guide-title="${sizeGuideTitle || 'Guía de tallas'}">Guía →</button>` : ''}
          </div>
          <div class="c4-modal__sizes">${sizesHtml}</div>
          <div class="c4-modal__ctas">
            <button class="c4-btn c4-btn--cta c4-btn--full" id="c4-modal-add">AGREGAR AL CARRITO</button>
            <button class="c4-btn c4-btn--primary c4-btn--full" id="c4-modal-buy">COMPRAR AHORA</button>
          </div>
        </div>
      </div>
    `;

    this.modal.querySelectorAll('.c4-pdp__size-btn:not(.is-soldout)').forEach(btn => {
      btn.addEventListener('click', () => {
        this.modal.querySelectorAll('.c4-pdp__size-btn').forEach(b => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        selectedVariant = product.variants.find(v => v.id == btn.dataset.variantId);
      });
    });

    this.modal.querySelector('#c4-modal-add')?.addEventListener('click', async () => {
      if (!selectedVariant) { alert('Selecciona una talla'); return; }
      await MMC4.CartDrawer.addItem(selectedVariant.id);
      this.close();
    });

    this.modal.querySelector('#c4-modal-buy')?.addEventListener('click', async () => {
      if (!selectedVariant) { alert('Selecciona una talla'); return; }
      await MMC4.buyNow(selectedVariant.id);
    });

    this.modal.querySelector('.c4-modal__close')?.addEventListener('click', () => this.close());
  },

  open() {
    this.modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  },

  close() {
    this.modal.classList.remove('is-open');
    document.body.style.overflow = '';
  },
};

/* ── Completa el Look ──────────────────────────
   Se abre con [data-c4-look-trigger] (ver c4-main-product.liquid).
   Todo pasa dentro del modal, sin navegar a otra página. El pool de
   piezas ya llegó pre-filtrado por stock desde Liquid (>= N variantes
   disponibles); aquí se vuelve a verificar contra /products/{handle}.js
   por si el inventario cambió entre el render de la página y el clic —
   ese endpoint siempre trae el estado más reciente de Shopify. ──── */
MMC4.CompleteLook = {
  modal: null,
  colorMap: {},

  init() {
    this.modal = document.querySelector('#c4-look-modal');

    const mapEl = document.querySelector('#c4-look-color-map');
    if (mapEl) {
      try { this.colorMap = JSON.parse(mapEl.textContent) || {}; } catch { this.colorMap = {}; }
    }

    if (!this.modal) return;

    document.addEventListener('click', async e => {
      const trigger = e.target.closest('[data-c4-look-trigger]');
      if (!trigger) return;
      e.preventDefault();
      await this.load(trigger);
    });

    this.modal.addEventListener('click', e => {
      if (e.target === this.modal) this.close();
    });
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') this.close();
    });
  },

  /* Se llama desde MMC4.PDPVariants cuando el cliente cambia de color
     swatch. Reemplaza al instante qué piezas ofrece "Completa el look"
     (sin recargar la página) para que combinen con el color elegido —
     usa el mapa color→look pre-calculado por Liquid en el servidor
     (#c4-look-color-map), que ya trae cada pieza pre-filtrada por stock.
     Si el color no tiene look propio, cae al "__default__". */
  syncColor(colorValue) {
    if (!colorValue) return;
    const key   = String(colorValue).toLowerCase().trim();
    const entry = this.colorMap[key] || this.colorMap.__default__;
    if (!entry) return;

    const trigger = document.querySelector('[data-c4-look-trigger]');
    const strip   = document.querySelector('[data-c4-look-strip]');
    if (!trigger || !strip) return;

    const section = strip.closest('.c4-section');
    if (section) section.hidden = entry.items.length === 0;
    if (entry.items.length === 0) return;

    trigger.dataset.c4LookId          = entry.lookId;
    trigger.dataset.c4LookAnchor      = entry.anchor;
    trigger.dataset.c4LookMinVariants = entry.minVariants;
    trigger.dataset.c4LookHandles     = entry.items.map(i => i.handle).join(',');

    const countEl = trigger.querySelector('[data-c4-look-count]');
    if (countEl) countEl.textContent = entry.items.length + 1;

    const mediaImg = document.querySelector('[data-c4-look-default-media]');
    if (mediaImg) {
      const colorImages = (MMC4.PDPGallery?.allImages || []).filter(img => img.alt === key);
      if (colorImages.length) mediaImg.src = colorImages[0].main;
    }

    strip.innerHTML = entry.items.slice(0, 3).map(item => `
      <div class="c4-look__row">
        <div class="c4-look__row-img"><img src="${item.image}" alt="${item.title}" loading="lazy"></div>
        <div class="c4-look__row-info">
          <p class="c4-look__row-vendor">${item.vendor}</p>
          <p class="c4-look__row-title">${item.title}</p>
          <p class="c4-look__row-price">${item.price}</p>
        </div>
        <span class="c4-look__row-stock">${item.stockLabel}</span>
      </div>
    `).join('');
  },

  async load(trigger) {
    const anchorHandle = trigger.dataset.c4LookAnchor;
    const lookId        = trigger.dataset.c4LookId;
    const minVariants    = parseInt(trigger.dataset.c4LookMinVariants || '3', 10);
    const handles = (trigger.dataset.c4LookHandles || '')
      .split(',').map(h => h.trim()).filter(Boolean);

    try {
      const [anchorProduct, ...complementProducts] = await Promise.all(
        [anchorHandle, ...handles].map(h => fetch(`/products/${h}.js`).then(r => r.json()))
      );

      const eligibleComplements = complementProducts.filter(
        p => p.variants.filter(v => v.available).length >= minVariants
      );
      if (eligibleComplements.length === 0) return;

      this.render(anchorProduct, eligibleComplements, lookId);
      this.open();
    } catch (e) { console.error('CompleteLook load:', e); }
  },

  itemRow(product) {
    const sizesHtml = product.variants.map(v => `
      <button class="c4-pdp__size-btn ${!v.available ? 'is-soldout' : ''}"
              data-variant-id="${v.id}" ${!v.available ? 'disabled' : ''}>
        ${v.title === 'Default Title' ? 'Talla única' : v.title}
      </button>
    `).join('');

    return `
      <div class="c4-look-modal__item" data-product-id="${product.id}">
        <div class="c4-look-modal__item-img"><img src="${product.featured_image}" alt="${product.title}"></div>
        <div class="c4-look-modal__item-info">
          <p class="c4-modal__brand">${product.vendor}</p>
          <p class="c4-modal__title" style="font-size:15px;">${product.title}</p>
          <p class="c4-modal__price">${MMC4.formatMoney(product.price)}</p>
          <div class="c4-look-modal__item-sizes">${sizesHtml}</div>
          <button type="button" class="c4-look-modal__item-add" disabled>AGREGAR</button>
        </div>
      </div>
    `;
  },

  render(anchorProduct, complements, lookId) {
    const items = [anchorProduct, ...complements];
    const cart  = {};

    this.modal.innerHTML = `
      <div class="c4-modal c4-modal--look">
        <button class="c4-modal__close" id="c4-look-close" aria-label="Cerrar"
                style="position:absolute;top:16px;right:16px;z-index:2;background:var(--c4-white);
                       width:34px;height:34px;border-radius:50%;display:flex;align-items:center;justify-content:center;">✕</button>
        <div class="c4-look-modal__images">
          ${items.map(p => `<img src="${p.featured_image}" alt="${p.title}">`).join('')}
        </div>
        <div class="c4-look-modal__panel">
          <div class="c4-look-modal__header">
            <p class="c4-look-modal__eyebrow">EL LOOK · ${items.length} PIEZAS DISPONIBLES</p>
            <h3 class="c4-look-modal__heading">Selecciona tu talla en cada pieza</h3>
          </div>
          <div class="c4-look-modal__list">
            ${items.map(p => this.itemRow(p)).join('')}
          </div>
          <div class="c4-look-modal__footer">
            <div>
              <p class="c4-look-modal__subtotal-label">SUBTOTAL DEL LOOK</p>
              <p class="c4-look-modal__subtotal-value" data-c4-look-subtotal>$0 MXN</p>
            </div>
            <button type="button" class="c4-btn c4-btn--cta" id="c4-look-add-all" disabled>Agregar el look completo</button>
          </div>
        </div>
      </div>
    `;

    const subtotalEl = this.modal.querySelector('[data-c4-look-subtotal]');
    const addAllBtn  = this.modal.querySelector('#c4-look-add-all');

    const updateSubtotal = () => {
      const total = items.filter(p => cart[p.id]).reduce((sum, p) => sum + p.price, 0);
      subtotalEl.textContent = MMC4.formatMoney(total);
      addAllBtn.disabled = items.every(p => cart[p.id]);
    };

    /* Cuando las N piezas del look ya están en el carrito, se etiqueta el
       cart con look_id vía cart attribute. La aplicación del descuento
       oculto (si se habilita) ocurre server-side leyendo ese atributo —
       el front nunca decide ni muestra ningún descuento al cliente. */
    const tagCartWithLook = async () => {
      if (!items.every(p => cart[p.id])) return;
      try {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { look_id: lookId } }),
        });
      } catch (e) { console.error('CompleteLook tag:', e); }
    };

    this.modal.querySelectorAll('.c4-look-modal__item').forEach(row => {
      const productId = row.dataset.productId;
      const addBtn    = row.querySelector('.c4-look-modal__item-add');
      let selectedVariantId = null;

      row.querySelectorAll('.c4-pdp__size-btn:not(.is-soldout)').forEach(btn => {
        btn.addEventListener('click', () => {
          row.querySelectorAll('.c4-pdp__size-btn').forEach(b => b.classList.remove('is-active'));
          btn.classList.add('is-active');
          selectedVariantId = btn.dataset.variantId;
          addBtn.disabled = false;
        });
      });

      addBtn.addEventListener('click', async () => {
        if (!selectedVariantId) return;
        try {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: selectedVariantId, quantity: 1 }),
          });
          cart[productId] = selectedVariantId;
          addBtn.textContent = 'AGREGADO ✓';
          addBtn.classList.add('is-added');
          addBtn.disabled = true;
          row.querySelectorAll('.c4-pdp__size-btn').forEach(b => b.disabled = true);
          updateSubtotal();
          await tagCartWithLook();
          MMC4.CartDrawer.fetchAndRender();
        } catch (e) { console.error('CompleteLook add item:', e); }
      });
    });

    addAllBtn.addEventListener('click', async () => {
      const toAdd = items.filter(p => !cart[p.id]).map(p => {
        const firstAvailable = p.variants.find(v => v.available);
        return firstAvailable ? { id: firstAvailable.id, quantity: 1 } : null;
      }).filter(Boolean);

      if (toAdd.length === 0) return;
      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: toAdd }),
        });
        toAdd.forEach(entry => {
          const product = items.find(p => p.variants.some(v => v.id === entry.id));
          if (product) cart[product.id] = entry.id;
        });
        updateSubtotal();
        await tagCartWithLook();
        this.close();
        MMC4.CartDrawer.open();
      } catch (e) { console.error('CompleteLook add all:', e); }
    });

    this.modal.querySelector('#c4-look-close')?.addEventListener('click', () => this.close());
  },

  open() {
    this.modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  },

  close() {
    this.modal.classList.remove('is-open');
    document.body.style.overflow = '';
  },
};

/* ── Guía de tallas — modal global (PDP, quick-add, PLP) ────
   Se abre con cualquier elemento [data-size-guide-trigger] que
   tenga data-size-guide-img (y opcionalmente data-size-guide-title).
   Nunca navega a otra página. ─────────────────────── */
MMC4.SizeGuide = {
  modal: null,

  init() {
    this.modal = document.querySelector('#c4-size-guide-modal');
    if (!this.modal) return;
    this.img   = document.querySelector('#c4-size-guide-img');
    this.title = document.querySelector('#c4-size-guide-title');

    document.addEventListener('click', e => {
      const trigger = e.target.closest('[data-size-guide-trigger]');
      if (!trigger) return;
      e.preventDefault();
      const src = trigger.dataset.sizeGuideImg;
      if (!src) return;
      this.open(src, trigger.dataset.sizeGuideTitle);
    });

    this.modal.addEventListener('click', e => {
      if (e.target === this.modal) this.close();
    });
    document.getElementById('c4-size-guide-close')?.addEventListener('click', () => this.close());
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') this.close();
    });
  },

  open(src, title) {
    if (!this.modal) return;
    if (this.img) this.img.src = src;
    if (this.title) this.title.textContent = title || 'Guía de tallas';
    this.modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  },

  close() {
    if (!this.modal) return;
    this.modal.classList.remove('is-open');
    document.body.style.overflow = '';
  },
};

/* ── Color Swatch Swap (0ms instantáneo) ─────────── */
MMC4.SwatchSwap = {
  init() {
    document.addEventListener('mouseenter', e => {
      if (!(e.target instanceof Element)) return;
      const swatch = e.target.closest('[data-c4-swatch-img]');
      if (!swatch) return;
      const img = swatch.closest('.c4-card')?.querySelector('.c4-card__img');
      if (img) {
        img._originalSrc = img._originalSrc || img.src;
        img.src = swatch.dataset.c4SwatchImg;
      }
    }, true);

    document.addEventListener('mouseleave', e => {
      if (!(e.target instanceof Element)) return;
      const swatch = e.target.closest('[data-c4-swatch-img]');
      if (!swatch) return;
      const img = swatch.closest('.c4-card')?.querySelector('.c4-card__img');
      if (img?._originalSrc) img.src = img._originalSrc;
    }, true);
  },
};

/* ── PDP Gallery — track swipeable (scroll-snap) + lightbox ──
   Las fotos se arman en JS a partir de #c4-pdp-images-data (todas las
   imágenes del producto con su color en minúsculas vía texto
   alternativo). Al elegir un color se vuelve a renderizar todo
   (miniaturas, foto principal, puntos) solo con las fotos de ese
   color — si ninguna foto trae ese color en el alt, se muestran todas
   para no dejar la galería vacía. */
MMC4.PDPGallery = {
  current: 0,
  allImages: [],
  images: [],

  init() {
    const wrap   = document.getElementById('c4-pdp-img-wrap');
    const dataEl = document.getElementById('c4-pdp-images-data');
    if (!wrap || !dataEl) return;

    try { this.allImages = JSON.parse(dataEl.textContent) || []; } catch { this.allImages = []; }
    if (!this.allImages.length) return;

    this.wrap    = wrap;
    this.thumbsEl = document.getElementById('c4-pdp-thumbs');
    this.dotsEl   = document.getElementById('c4-pdp-dots');

    document.querySelector('.c4-pdp__arrow--prev')
      ?.addEventListener('click', () => this.goTo(this.current - 1));
    document.querySelector('.c4-pdp__arrow--next')
      ?.addEventListener('click', () => this.goTo(this.current + 1));

    let scrollTimeout;
    wrap.addEventListener('scroll', () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        const idx = Math.round(wrap.scrollLeft / (wrap.clientWidth || 1));
        this.syncActive(idx);
      }, 80);
    }, { passive: true });

    // El botón de lupa (no la imagen completa) abre el lightbox a pantalla
    // completa. Antes estaba en toda la imagen, pero en móvil un toque para
    // deslizar entre fotos también dispara "click" y abría el zoom por error,
    // tapando tallas/descripción/todo lo demás del PDP.
    document.getElementById('c4-pdp-zoom-btn')
      ?.addEventListener('click', () => MMC4.PDPLightbox.open(this.current, this.images));

    MMC4.PDPLightbox.init();

    const initialColor = document.querySelector('.c4-pdp__gallery')?.dataset.initialColor || '';
    this.filterByColor(initialColor);
  },

  /* Filtra la galería a solo las fotos cuyo alt coincida con este
     color; si ninguna coincide, muestra todas (evita galería vacía en
     productos que aún no tienen las fotos etiquetadas por color). */
  filterByColor(colorName) {
    const dc = (colorName || '').toLowerCase().trim();
    let filtered = dc ? this.allImages.filter(img => img.alt === dc) : this.allImages;
    if (!filtered.length) filtered = this.allImages;
    this.images = filtered;
    this.render();
  },

  render() {
    if (!this.wrap) return;

    this.wrap.innerHTML = this.images.map((img, i) => `
      <img class="c4-pdp__slide-img" data-index="${i}" src="${img.main}" alt=""
           loading="${i === 0 ? 'eager' : 'lazy'}">
    `).join('');
    this.slides = this.wrap.querySelectorAll('.c4-pdp__slide-img');

    if (this.thumbsEl) {
      this.thumbsEl.innerHTML = this.images.map((img, i) => `
        <div class="c4-pdp__thumb${i === 0 ? ' is-active' : ''}">
          <img src="${img.thumb}" alt="" width="200" height="200" loading="lazy">
        </div>
      `).join('');
      this.thumbs = this.thumbsEl.querySelectorAll('.c4-pdp__thumb');
      this.thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => this.goTo(i)));
    }

    if (this.dotsEl) {
      this.dotsEl.innerHTML = this.images.map((_, i) => `
        <span class="c4-pdp__dot${i === 0 ? ' is-active' : ''}" data-index="${i}"></span>
      `).join('');
      this.dots = this.dotsEl.querySelectorAll('.c4-pdp__dot');
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.goTo(i)));
    }

    this.current = 0;
    this.wrap.scrollLeft = 0;
  },

  goTo(index) {
    if (!this.slides?.length) return;
    const i = Math.max(0, Math.min(index, this.slides.length - 1));
    const slide = this.slides[i];
    if (slide && this.wrap) {
      this.wrap.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    }
    this.syncActive(i);
  },

  syncActive(index) {
    this.current = index;
    this.thumbs?.forEach((t, i) => t.classList.toggle('is-active', i === index));
    this.dots?.forEach((d, i) => d.classList.toggle('is-active', i === index));
  },
};

/* ── PDP Lightbox — galería a pantalla completa ─────────── */
MMC4.PDPLightbox = {
  ready: false,

  init() {
    if (this.ready) return;
    this.el     = document.getElementById('c4-pdp-lightbox');
    this.track  = document.getElementById('c4-pdp-lightbox-track');
    this.dotsEl = document.getElementById('c4-pdp-lightbox-dots');
    if (!this.el || !this.track) return;
    this.ready = true;

    document.getElementById('c4-pdp-lightbox-close')
      ?.addEventListener('click', () => this.close());
    this.el.addEventListener('click', e => {
      if (e.target === this.el) this.close();
    });
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && !this.el.hidden) this.close();
    });

    let scrollTimeout;
    this.track.addEventListener('scroll', () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        const idx = Math.round(this.track.scrollLeft / (this.track.clientWidth || 1));
        this.dots?.forEach((d, i) => d.classList.toggle('is-active', i === idx));
      }, 80);
    }, { passive: true });
  },

  /* images = arreglo de la galería visible actual (MMC4.PDPGallery.images),
     para que el visor a pantalla completa muestre solo las fotos del
     color que se está viendo, no todas las del producto. */
  open(index = 0, images = []) {
    if (!this.el || !this.track) return;

    this.track.innerHTML = images.map(img => `<img src="${img.zoom}" alt="" loading="lazy">`).join('');
    if (this.dotsEl) {
      this.dotsEl.innerHTML = images.map((_, i) => `
        <span class="c4-pdp__dot${i === index ? ' is-active' : ''}"></span>
      `).join('');
      this.dots = this.dotsEl.querySelectorAll('.c4-pdp__dot');
    }

    this.el.hidden = false;
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(() => {
      const slide = this.track.children[index];
      if (slide) this.track.scrollLeft = slide.offsetLeft;
    });
  },

  close() {
    if (!this.el) return;
    this.el.hidden = true;
    document.body.style.overflow = '';
  },
};

/* ── PDP Variant Selection ───────────────── */
MMC4.PDPVariants = {
  init() {
    const form    = document.querySelector('[data-c4-pdp-form]');
    const jsonEl  = document.querySelector('[data-c4-product-json]');
    if (!form || !jsonEl) return;

    let product;
    try { product = JSON.parse(jsonEl.textContent); } catch { return; }

    const variantInput = form.querySelector('[name="id"]');
    const sizeBtns     = form.querySelectorAll('.c4-pdp__size-btn');
    const colorSwatches = form.querySelectorAll('.c4-pdp__color-swatch');
    const priceEl      = form.querySelector('[data-c4-price]');
    const msiEl        = form.querySelector('[data-c4-msi]');
    const addBtn       = form.querySelector('[data-c4-add-btn]');
    const buyNowBtn     = document.querySelector('[data-c4-buy-now]');

    // Detecta en qué posición (1, 2 o 3) vive cada opción por su
    // significado, no por que el nombre coincida exacto con
    // "Color"/"Talla" — Shopify nombra la opción distinto según la
    // categoría del producto (ej. Calzado usa "Talla del calzado"),
    // así que basta con que el nombre CONTENGA la palabra clave.
    const colorPos = product.options.findIndex(o => /color|colour/i.test(o)) + 1;
    const sizePos  = product.options.findIndex(o => /talla|size/i.test(o)) + 1;

    // Arranca con los valores de la variante ya seleccionada en el
    // servidor, para que si el cliente solo toca una opción (ej. solo
    // color) la otra (talla) no se pierda.
    const initialVariant = product.variants.find(v => String(v.id) === String(variantInput.value));
    const selectedOptionValues = {};
    if (initialVariant) {
      product.options.forEach((_, i) => {
        selectedOptionValues[i + 1] = initialVariant[`option${i + 1}`];
      });
    }

    const updateVariant = () => {
      const variant = product.variants.find(v =>
        Object.keys(selectedOptionValues).every(pos =>
          v[`option${pos}`] === selectedOptionValues[pos]
        )
      );
      if (!variant) return;
      variantInput.value = variant.id;

      const onSale = variant.compare_at_price > variant.price;
      if (priceEl) {
        priceEl.innerHTML = onSale
          ? `<span style="font-size:15px;font-weight:400;color:var(--c4-outline);text-decoration:line-through;margin-right:8px;">${MMC4.formatMoney(variant.compare_at_price)}</span>`
            + `<span style="color:var(--c4-error);">${MMC4.formatMoney(variant.price)}</span>`
          : MMC4.formatMoney(variant.price);
      }
      if (addBtn) addBtn.disabled = !variant.available;

      // Update MSI table. No aplica en variantes con rebaja/promoción; los
      // renglones solo existen en el DOM si Liquid los renderizó según el
      // umbral configurado, así que querySelectorAll no hace nada si no hay.
      if (msiEl) {
        msiEl.hidden = onSale;
        if (!onSale && variant.price) {
          msiEl.querySelectorAll('[data-msi-3]').forEach(el => el.textContent = MMC4.formatMoney(variant.price / 3));
          msiEl.querySelectorAll('[data-msi-6]').forEach(el => el.textContent = MMC4.formatMoney(variant.price / 6));
        }
      }
    };

    // Recalcula, con los datos reales de product.variants, qué tallas
    // existen y tienen stock para el color actualmente seleccionado.
    // Nada de listas fijas: si Shopify no tiene esa combinación
    // color+talla, o la tiene sin inventario, se marca agotada.
    const refreshSizeAvailability = () => {
      if (sizePos === 0) return;
      sizeBtns.forEach(btn => {
        const size = btn.dataset.size || btn.textContent.trim();
        const candidate = { ...selectedOptionValues, [sizePos]: size };
        const variant = product.variants.find(v =>
          Object.keys(candidate).every(pos => v[`option${pos}`] === candidate[pos])
        );
        const available = !!(variant && variant.available);
        btn.classList.toggle('is-soldout', !available);
        btn.disabled = !available;
        btn.setAttribute('aria-label', available ? '' : `${size} — Agotado`);
      });
    };
    refreshSizeAvailability();

    sizeBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        if (btn.classList.contains('is-soldout')) return;
        sizeBtns.forEach(b => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        if (sizePos > 0) {
          selectedOptionValues[sizePos] = btn.dataset.size || btn.textContent.trim();
        }
        updateVariant();
      });
    });

    const colorLabel = document.getElementById('c4-pdp-color-label');

    colorSwatches.forEach(swatch => {
      swatch.addEventListener('click', () => {
        colorSwatches.forEach(s => s.classList.remove('is-active'));
        swatch.classList.add('is-active');
        if (colorPos > 0) {
          selectedOptionValues[colorPos] = swatch.dataset.color;
        }
        if (colorLabel && swatch.dataset.color) {
          colorLabel.textContent = swatch.dataset.color.toUpperCase();
        }
        refreshSizeAvailability();
        updateVariant();
        MMC4.PDPGallery.filterByColor?.(swatch.dataset.color);
        MMC4.CompleteLook.syncColor?.(swatch.dataset.color);
      });
    });

    form.addEventListener('submit', async e => {
      e.preventDefault();
      if (!variantInput.value) { alert('Selecciona una talla'); return; }
      addBtn.disabled = true;
      addBtn.textContent = 'Agregando...';
      await MMC4.CartDrawer.addItem(variantInput.value);
      addBtn.disabled = false;
      addBtn.textContent = addBtn.dataset.label || 'AGREGAR AL CARRITO';
    });

    buyNowBtn?.addEventListener('click', async () => {
      if (!variantInput.value) { alert('Selecciona una talla'); return; }
      buyNowBtn.disabled = true;
      buyNowBtn.textContent = 'Procesando...';
      await MMC4.buyNow(variantInput.value);
    });
  },
};

/* ── Infinite Scroll PLP ───────────────────── */
MMC4.InfiniteScroll = {
  init() {
    const grid     = document.querySelector('[data-c4-plp-grid]');
    const sentinel = document.querySelector('[data-c4-sentinel]');
    if (!grid || !sentinel) return;

    let page = 1, busy = false, done = false;

    const obs = new IntersectionObserver(entries => {
      if (!entries[0].isIntersecting || busy || done) return;
      busy = true;
      this.load(grid, ++page)
        .then(hasMore => { if (!hasMore) done = true; })
        .finally(() => { busy = false; });
    }, { rootMargin: '200px' });

    obs.observe(sentinel);
  },

  async load(grid, page) {
    const url = new URL(window.location.href);
    url.searchParams.set('page', page);

    const sentinel = document.querySelector('[data-c4-sentinel]');
    if (sentinel) {
      sentinel.innerHTML = this.skeletonHtml(4);
    }

    try {
      const res  = await fetch(url.href, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      const html = await res.text();
      const doc  = new DOMParser().parseFromString(html, 'text/html');
      const cards = doc.querySelectorAll('[data-c4-plp-grid] .c4-card');

      if (sentinel) sentinel.innerHTML = '';

      if (!cards.length) return false;

      cards.forEach(card => {
        card.style.opacity = '0';
        card.style.transform = 'translateY(16px)';
        grid.insertBefore(card, sentinel);
        requestAnimationFrame(() => {
          card.style.transition = 'opacity 0.4s ease, transform 0.4s ease';
          card.style.opacity = '1';
          card.style.transform = '';
        });
      });

      return true;
    } catch { if (sentinel) sentinel.innerHTML = ''; return false; }
  },

  skeletonHtml(n) {
    return Array.from({ length: n }, () => `
      <div class="c4-card">
        <div class="c4-skeleton" style="aspect-ratio:3/4;margin-bottom:24px;"></div>
        <div class="c4-skeleton" style="height:10px;width:50%;margin-bottom:8px;"></div>
        <div class="c4-skeleton" style="height:14px;width:75%;margin-bottom:8px;"></div>
        <div class="c4-skeleton" style="height:15px;width:35%;"></div>
      </div>
    `).join('');
  },
};

/* ── Clips Feed ─────────────────────────── */
MMC4.ClipsFeed = {
  init() {
    const feed = document.querySelector('.c4-clips-feed');
    if (!feed) return;

    const clips = feed.querySelectorAll('.c4-clip');
    clips[0]?.querySelector('video')?.play().catch(() => {});

    const obs = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const vid = entry.target.querySelector('video');
        if (!vid) return;
        entry.isIntersecting ? vid.play().catch(() => {}) : vid.pause();
      });
    }, { threshold: 0.7 });

    clips.forEach(clip => obs.observe(clip));

    feed.addEventListener('click', e => {
      const btn = e.target.closest('[data-c4-mute]');
      if (!btn) return;
      const vid = btn.closest('.c4-clip')?.querySelector('video');
      if (!vid) return;
      vid.muted = !vid.muted;
      btn.textContent = vid.muted ? '🔇' : '🔊';
    });
  },
};

/* ── Carousel Arrow Nav ──────────────────── */
MMC4.Carousels = {
  init() {
    document.querySelectorAll('.c4-carousel').forEach(carousel => {
      const track = carousel.querySelector('.c4-carousel__track');
      const prev  = carousel.querySelector('.c4-carousel__btn--prev');
      const next  = carousel.querySelector('.c4-carousel__btn--next');
      if (!track) return;

      const scrollBy = () => (track.querySelector('.c4-carousel__slide')?.offsetWidth || 280) + 24;

      prev?.addEventListener('click', () => track.scrollBy({ left: -scrollBy(), behavior: 'smooth' }));
      next?.addEventListener('click', () => track.scrollBy({ left:  scrollBy(), behavior: 'smooth' }));
    });
  },
};

/* ── Mobile Menu ───────────────────────── */
MMC4.MobileMenu = {
  init() {
    const toggle  = document.querySelector('[data-c4-menu-toggle]');
    const drawer  = document.querySelector('[data-c4-menu-drawer]');
    const close   = document.querySelector('[data-c4-menu-close]');
    if (!toggle || !drawer) return;

    toggle.addEventListener('click', () => {
      drawer.classList.toggle('is-open');
      document.body.style.overflow = drawer.classList.contains('is-open') ? 'hidden' : '';
    });
    close?.addEventListener('click', () => {
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  },
};

/* ── Wishlist (localStorage) ──────────────── */
MMC4.Wishlist = {
  key: 'mm_c4_wishlist',
  get()       { try { return JSON.parse(localStorage.getItem(this.key)) || []; } catch { return []; } },
  set(list)   { localStorage.setItem(this.key, JSON.stringify(list)); },
  has(id)     { return this.get().includes(String(id)); },
  toggle(id)  {
    const list = this.get(), sid = String(id), idx = list.indexOf(sid);
    if (idx > -1) list.splice(idx, 1); else list.push(sid);
    this.set(list);
    return idx === -1;
  },

  init() {
    this.get().forEach(id => {
      document.querySelectorAll(`[data-c4-wishlist="${id}"]`).forEach(btn =>
        btn.classList.add('is-active')
      );
    });

    document.addEventListener('click', e => {
      const btn = e.target.closest('[data-c4-wishlist]');
      if (!btn) return;
      e.preventDefault();
      const added = this.toggle(btn.dataset.c4Wishlist);
      btn.classList.toggle('is-active', added);
      btn.style.transform = 'scale(1.3)';
      setTimeout(() => { btn.style.transform = ''; }, 180);
    });
  },
};

/* ── Filter Chips (PLP) ──────────────────── */
MMC4.FilterChips = {
  init() {
    document.querySelectorAll('.c4-filter-chip').forEach(chip => {
      chip.addEventListener('click', () => {
        const group = chip.closest('.c4-filter-chips');
        group?.querySelectorAll('.c4-filter-chip').forEach(c => c.classList.remove('is-active'));
        chip.classList.add('is-active');
      });
    });
  },
};

/* ── Newsletter ────────────────────────── */
MMC4.Newsletter = {
  init() {
    document.querySelectorAll('[data-c4-newsletter]').forEach(form => {
      form.addEventListener('submit', async e => {
        e.preventDefault();
        const input = form.querySelector('[type="email"]');
        const btn   = form.querySelector('button[type="submit"]');
        const msg   = form.querySelector('[data-c4-nl-msg]');
        if (!input?.value) return;
        btn.disabled = true;
        btn.textContent = '...';
        try {
          const fd = new FormData();
          fd.append('form_type', 'customer');
          fd.append('email', input.value);
          await fetch('/contact', { method: 'POST', body: fd });
          if (msg) { msg.textContent = '¡Bienvenida a la mansión!'; msg.style.display = 'block'; }
          form.reset();
        } finally { btn.disabled = false; btn.textContent = 'SUSCRIBIRSE'; }
      });
    });
  },
};

/* ── Toast ─────────────────────────────── */
MMC4.showToast = (msg) => {
  const toast = document.getElementById('c4-toast');
  const msgEl  = document.getElementById('c4-toast-msg');
  if (!toast) return;
  if (msgEl) msgEl.textContent = msg;
  toast.classList.add('is-visible');
  clearTimeout(toast._hideTimer);
  toast._hideTimer = setTimeout(() => toast.classList.remove('is-visible'), 3200);
};

MMC4.initToast = () => {
  document.getElementById('c4-toast-close')?.addEventListener('click', () =>
    document.getElementById('c4-toast')?.classList.remove('is-visible')
  );
};

/* ── Home Video Grid — autoplay on scroll ────────── */
MMC4.HomeVideoGrid = {
  observer: null,

  init() {
    this.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const vid = entry.target;
        entry.isIntersecting ? vid.play().catch(() => {}) : vid.pause();
      });
    }, { threshold: 0.5 });
  },

  bindVideos(container) {
    container.querySelectorAll('video[data-c4-home-vid]').forEach(vid =>
      this.observer?.observe(vid)
    );
  },
};

/* ── Inline Size Picker ─────────────────── */
MMC4.InlineSizePicker = {

  init() {
    document.addEventListener('click', async e => {
      const btn = e.target.closest('[data-c4-inline-size]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();

      const handle = btn.dataset.c4InlineSize;
      const card   = btn.closest('.c4-card');
      if (!handle || !card) return;

      const tray = card.querySelector('.c4-card__size-tray');
      if (!tray) return;

      if (!tray.hidden) { this.closeTray(tray); return; }

      // Close any other open tray first
      document.querySelectorAll('.c4-card__size-tray:not([hidden])').forEach(t =>
        this.closeTray(t)
      );

      await this.openTray(tray, handle, card);
    });

    // Close when clicking outside a card
    document.addEventListener('click', e => {
      if (!e.target.closest('.c4-card')) {
        document.querySelectorAll('.c4-card__size-tray:not([hidden])').forEach(t =>
          this.closeTray(t)
        );
      }
    });
  },

  // No extra binding needed — fully delegated
  bindCards() {},

  async openTray(tray, handle, card) {
    tray.hidden = false;
    // Allow display before animating
    requestAnimationFrame(() => tray.classList.add('is-open'));

    const sizesEl = tray.querySelector('.c4-card__size-tray__sizes');
    if (!sizesEl || sizesEl.dataset.loaded === handle) return;

    try {
      const res     = await fetch(`/products/${handle}.js`);
      const product = await res.json();
      sizesEl.dataset.loaded = handle;

      sizesEl.innerHTML = product.variants.map(v => `
        <button class="c4-size-pill${!v.available ? ' is-soldout' : ''}"
                data-variant-id="${v.id}"
                ${!v.available ? 'disabled' : ''}>
          ${v.title === 'Default Title' ? 'Único' : v.title}
        </button>
      `).join('');

      sizesEl.querySelectorAll('.c4-size-pill:not(.is-soldout)').forEach(pill => {
        pill.addEventListener('click', async () => {
          sizesEl.querySelectorAll('.c4-size-pill').forEach(p => p.classList.remove('is-selected'));
          pill.classList.add('is-selected');
          const originalText = pill.textContent.trim();
          pill.textContent = '✓';

          await this.addToCart(pill.dataset.variantId, product.vendor, product.title);

          setTimeout(() => {
            pill.textContent = originalText;
            this.closeTray(tray);
          }, 700);
        });
      });

    } catch (err) {
      console.error('Size tray:', err);
      if (sizesEl) sizesEl.innerHTML =
        '<p style="font-size:11px;color:var(--c4-error);padding:4px 0;">Error. Intenta de nuevo.</p>';
    }
  },

  closeTray(tray) {
    tray.classList.remove('is-open');
    setTimeout(() => { tray.hidden = true; }, 280);
  },

  async addToCart(variantId, vendor, title) {
    try {
      await fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ id: variantId, quantity: 1 }),
      });

      // Refresh cart count badge
      const cartRes  = await fetch('/cart.js');
      const cartData = await cartRes.json();
      document.querySelectorAll('[data-c4-cart-count]').forEach(el => {
        el.textContent = cartData.item_count;
        el.style.display = cartData.item_count > 0 ? 'flex' : 'none';
      });

      const label = vendor ? `${vendor} — Agregado` : 'Agregado al carrito';
      MMC4.showToast(label);

    } catch (err) {
      console.error('Inline add to cart:', err);
    }
  },
};

/* ── Home PLP — AJAX product loader ──────────── */
MMC4.HomePLP = {
  activeCollection: null,
  activeTag:        null,
  currentPage:      1,
  fetchPage:        1,
  exhausted:        false,
  loading:          false,
  totalCount:       0,

  init() {
    if (!document.getElementById('c4-home-plp')) return;

    // Category button clicks
    document.querySelectorAll('.c4-hero__cat-item').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const handle = btn.dataset.collection;
        if (!handle) return;

        if (this.activeCollection === handle) {
          this.close(); return;
        }

        document.querySelectorAll('.c4-hero__cat-item').forEach(b =>
          b.classList.remove('is-active')
        );
        btn.classList.add('is-active');

        this.activeCollection = handle;
        this.activeTag        = null;
        this.open(handle);
      });
    });

    document.getElementById('c4-plp-close')?.addEventListener('click', () => this.close());

    document.getElementById('c4-home-sort')?.addEventListener('change', e => {
      this.currentPage = 1;
      this.load(true);
    });

    document.getElementById('c4-loadmore-btn')?.addEventListener('click', () => {
      this.load(false); // fetchPage avanza internamente en load()
    });

    this.initStickyHeader();
  },

  initStickyHeader() {
    const hero   = document.querySelector('.c4-hero');
    const header = document.querySelector('.c4-home-plp__header');
    if (!hero || !header) return;

    // Sombra cuando el hero sale de vista
    const obs = new IntersectionObserver(([entry]) => {
      header.classList.toggle('is-sticky', !entry.isIntersecting);
    }, { threshold: 0 });
    obs.observe(hero);

    let lastY   = window.scrollY;
    let ticking = false;

    window.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const currentY  = window.scrollY;
        const goingDown = currentY > lastY;
        const heroH     = hero.offsetHeight || 300;
        const pastHero  = currentY > heroH;
        // Solo mostrar la barra cuando el usuario esté cerca del inicio del PLP.
        // Fuera de esa zona (en medio de los productos), la barra permanece oculta
        // para evitar el efecto flotante.
        const nearPLPTop = currentY <= heroH + 120;

        if (goingDown && pastHero) {
          header.classList.add('is-hidden');
        } else if (!goingDown && nearPLPTop) {
          header.classList.remove('is-hidden');
        }
        // Si va hacia arriba pero aún está en los productos → barra sigue oculta

        lastY   = currentY;
        ticking = false;
      });
    }, { passive: true });
  },

  open(handle) {
    const plp = document.getElementById('c4-home-plp');
    if (!plp) return;

    plp.hidden = false;
    plp.classList.add('is-visible');

    const catData = window.c4HomeCategories?.[handle];
    const label   = document.getElementById('c4-active-cat-label');
    if (label) label.textContent = catData?.label || handle;

    this.renderChips(handle);
    this.currentPage = 1;
    this.load(true);

    setTimeout(() =>
      plp.scrollIntoView({ behavior: 'smooth', block: 'start' }), 60
    );
  },

  close() {
    const plp = document.getElementById('c4-home-plp');
    plp?.classList.remove('is-visible');
    setTimeout(() => { if (plp) plp.hidden = true; }, 300);

    document.querySelectorAll('.c4-hero__cat-item').forEach(b =>
      b.classList.remove('is-active')
    );

    this.activeCollection = null;
    this.activeTag        = null;
  },

  renderChips(handle) {
    const container = document.getElementById('c4-home-chips');
    if (!container) return;

    const catData = window.c4HomeCategories?.[handle];
    if (!catData?.chips?.length) { container.innerHTML = ''; return; }

    // No pre-filter by tag — show all products first; chips filter on click
    this.activeTag = null;

    container.innerHTML = catData.chips.map((chip) => `
      <button class="c4-filter-chip"
              data-tag="${chip.tag || ''}" data-c4-home-chip>
        ${chip.label}
      </button>
    `).join('');

    container.querySelectorAll('[data-c4-home-chip]').forEach(chip => {
      chip.addEventListener('click', () => {
        container.querySelectorAll('[data-c4-home-chip]').forEach(c =>
          c.classList.remove('is-active')
        );
        chip.classList.add('is-active');
        this.activeTag   = chip.dataset.tag || null;
        this.currentPage = 1;
        this.load(true);
      });
    });
  },

  async load(reset) {
    if (this.loading) return;
    this.loading = true;

    const grid    = document.getElementById('c4-home-grid');
    const toolbar = document.getElementById('c4-home-toolbar');
    const countEl = document.getElementById('c4-home-count');
    const loadBtn = document.getElementById('c4-home-loadmore');
    const sort    = document.getElementById('c4-home-sort')?.value || 'created-descending';

    if (!grid) { this.loading = false; return; }

    if (reset) {
      grid.innerHTML  = this.skeletonHtml();
      this.totalCount = 0;
      this.fetchPage  = 1;
      this.exhausted  = false;
    }

    const PAGE_SIZE = 12;

    try {
      let collected = [];

      while (collected.length < PAGE_SIZE && !this.exhausted) {
        const url = `/collections/${this.activeCollection}/products.json` +
                    `?limit=250&page=${this.fetchPage}&sort_by=${sort}`;

        console.log('[MM HomePLP] Fetching:', url);

        const res = await fetch(url);
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data  = await res.json();
        const batch = data.products || [];

        console.log('[MM HomePLP] Batch recibido:', batch.length, 'productos');
        if (batch.length > 0) {
          console.log('[MM HomePLP] Primer producto:', batch[0].title, '| tags:', batch[0].tags);
          console.log('[MM HomePLP] activeTag:', this.activeTag);
        }

        if (!batch.length) { this.exhausted = true; break; }

        const filtered = this.activeTag
          ? batch.filter(p => {
              const tags = Array.isArray(p.tags)
                ? p.tags
                : (typeof p.tags === 'string' ? p.tags.split(',').map(t => t.trim()) : []);
              return tags.some(t => t.toLowerCase() === this.activeTag.toLowerCase());
            })
          : batch;

        console.log('[MM HomePLP] Después de filtro:', filtered.length, 'productos');

        collected = collected.concat(filtered);
        this.fetchPage++;

        if (batch.length < 250) this.exhausted = true;
      }

      if (reset) grid.innerHTML = '';

      // toolbar oculto intencionalmente

      if (!collected.length && reset) {
        grid.innerHTML = '<p class="c4-home-plp__empty">No hay productos en esta categoría.</p>';
        if (loadBtn) loadBtn.style.display = 'none';
        return;
      }

      this.totalCount += collected.length;
      if (countEl) countEl.textContent = `${this.totalCount} pieza${this.totalCount !== 1 ? 's' : ''}`;

      collected.forEach((product, i) => {
        const globalIndex = reset ? i : grid.children.length + i;
        const card = this.buildCard(product, globalIndex);
        card.style.opacity   = '0';
        card.style.transform = 'translateY(12px)';
        grid.appendChild(card);
        requestAnimationFrame(() => {
          card.style.transition = 'opacity 0.35s ease, transform 0.35s ease';
          card.style.opacity    = '1';
          card.style.transform  = '';
        });
      });

      MMC4.HomeVideoGrid.bindVideos(grid);
      MMC4.Wishlist.init(); // re-init to catch new wishlist buttons

      if (loadBtn) {
        loadBtn.style.display = this.exhausted ? 'none' : 'flex';
      }

    } catch (err) {
      console.error('HomePLP load:', err);
      if (reset) grid.innerHTML =
        '<p class="c4-home-plp__empty">Error al cargar. Intenta de nuevo.</p>';
    } finally {
      this.loading = false;
    }
  },

  buildCard(product, index) {
    const rawPrice     = product.price_min ?? product.price ?? product.variants?.[0]?.price ?? 0;
    const rawCompare   = product.compare_at_price_min ?? product.compare_at_price ?? 0;
    const price        = MMC4.formatMoneyFromPesos(rawPrice);
    const comparePrice = rawCompare > rawPrice ? MMC4.formatMoneyFromPesos(rawCompare) : null;
    const onSale = !!comparePrice;
    const isNew  = product.tags?.some(t => ['nuevo','new','nueva-llegada'].includes(t));
    const isWide = (index % 5 === 4); // every 5th card spans 2 cols

    const imgBase = (src) => {
      const s = typeof src === 'string' ? src : src?.src || '';
      return s ? s.replace(/\?.*/, '') + '?width=600' : '';
    };
    const mainImg = imgBase(product.featured_image) || imgBase(product.images?.[0]);
    const allImgs = product.images?.map(img => imgBase(img.src || img)) || [mainImg];

    // Swatches
    const seenColors = new Set();
    const swatchHtml = (product.variants || []).slice(0, 6).reduce((acc, v) => {
      if (!seenColors.has(v.option1) && v.featured_image?.src) {
        seenColors.add(v.option1);
        acc += `<span class="c4-card__swatch"
          data-c4-swatch-img="${imgBase(v.featured_image.src)}"
          style="background:${v.option1.toLowerCase().replace(/\s+/g,'-')};"
          title="${v.option1}"></span>`;
      }
      return acc;
    }, '');

    const dotsHtml = allImgs.length > 1
      ? `<div class="c4-card__dots">${allImgs.slice(0,4).map((_, i) =>
          `<span class="c4-card__dot${i === 0 ? ' is-active' : ''}"></span>`
        ).join('')}</div>`
      : '';

    const arrowsHtml = allImgs.length > 1
      ? `<div class="c4-card__nav-arrows">
           <button class="c4-card__arrow c4-card__arrow--prev" aria-label="Foto anterior">‹</button>
           <button class="c4-card__arrow c4-card__arrow--next" aria-label="Siguiente">›</button>
         </div>`
      : '';

    const article = document.createElement('article');
    article.className = `c4-card c4-home-card${isWide ? ' c4-masonry__card-wide' : ''}`;
    article.dataset.productId     = product.id;
    article.dataset.productHandle = product.handle;

    article.innerHTML = `
      <div class="c4-card__media">
        <a href="/products/${product.handle}" aria-label="${product.title}">
          <img class="c4-card__img" src="${mainImg}" alt="${product.title}" loading="lazy">
        </a>
        ${isNew    ? '<span class="c4-card__badge c4-card__badge--new">NUEVA LLEGADA</span>' : ''}
        ${!isNew && onSale ? '<span class="c4-card__badge c4-card__badge--sale">SALE</span>' : ''}
        <button class="c4-card__wishlist" data-c4-wishlist="${product.id}" aria-label="Wishlist">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
            <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
          </svg>
        </button>
        ${arrowsHtml}
        <div class="c4-card__quick-add">
          <button class="c4-card__add-btn"
                  data-c4-inline-size="${product.handle}"
                  aria-label="Ver tallas">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
            </svg>
          </button>
        </div>
        ${dotsHtml}
      </div>
      <div class="c4-card__size-tray" hidden>
        <div class="c4-card__size-tray__inner">
          <div class="c4-card__size-tray__header">
            <span>Selecciona talla</span>
          </div>
          <div class="c4-card__size-tray__sizes" data-product-handle="${product.handle}">
            <div class="c4-skeleton" style="height:32px;width:100%;"></div>
          </div>
        </div>
      </div>
      <div class="c4-card__info">
        <p class="c4-card__brand">${(product.vendor || 'MARCA').toUpperCase()}</p>
        <p class="c4-card__title">
          <a href="/products/${product.handle}">${product.title}</a>
        </p>
        ${swatchHtml ? `<div class="c4-card__swatches">${swatchHtml}</div>` : ''}
        <div class="c4-card__price">
          <span class="c4-card__price-main${onSale ? ' c4-card__price-sale' : ''}">${price}</span>
          ${comparePrice ? `<span class="c4-card__price-compare">${comparePrice}</span>` : ''}
        </div>
      </div>
    `;

    // Wire photo navigation
    if (allImgs.length > 1) {
      let current = 0;
      const img   = article.querySelector('.c4-card__img');
      const dots  = article.querySelectorAll('.c4-card__dot');

      const goTo = (idx) => {
        current = (idx + allImgs.length) % allImgs.length;
        if (img) img.src = allImgs[current];
        dots.forEach((d, i) => d.classList.toggle('is-active', i === current));
      };

      article.querySelector('.c4-card__arrow--prev')?.addEventListener('click', e => {
        e.preventDefault(); e.stopPropagation(); goTo(current - 1);
      });
      article.querySelector('.c4-card__arrow--next')?.addEventListener('click', e => {
        e.preventDefault(); e.stopPropagation(); goTo(current + 1);
      });

      // Swipe táctil (móvil) sobre la imagen del card
      const media = article.querySelector('.c4-card__media');
      if (media) {
        let touchStartX = 0, touchStartY = 0, isSwiping = false;
        const SWIPE_THRESHOLD = 30; // px mínimos para contar como swipe

        media.addEventListener('touchstart', e => {
          touchStartX = e.touches[0].clientX;
          touchStartY = e.touches[0].clientY;
          isSwiping = false;
        }, { passive: true });

        media.addEventListener('touchmove', e => {
          const dx = e.touches[0].clientX - touchStartX;
          const dy = e.touches[0].clientY - touchStartY;
          if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 10) {
            isSwiping = true; // gesto horizontal: bloquea el link/scroll vertical
            e.preventDefault();
          }
        }, { passive: false });

        media.addEventListener('touchend', e => {
          if (!isSwiping) return;
          const dx = e.changedTouches[0].clientX - touchStartX;
          if (Math.abs(dx) >= SWIPE_THRESHOLD) {
            goTo(current + (dx < 0 ? 1 : -1));
          }
          isSwiping = false;
        }, { passive: true });

        // Evita que el swipe horizontal dispare la navegación al PDP
        media.querySelector('a')?.addEventListener('click', e => {
          if (isSwiping) { e.preventDefault(); }
        });
      }
    }

    return article;
  },

  skeletonHtml() {
    return Array.from({ length: 6 }, (_, i) => `
      <article class="c4-card${i % 5 === 4 ? ' c4-masonry__card-wide' : ''}">
        <div class="c4-card__media">
          <div class="c4-skeleton" style="width:100%;aspect-ratio:3/4;"></div>
        </div>
        <div class="c4-card__info" style="padding-top:8px;">
          <div class="c4-skeleton" style="height:10px;width:50%;margin-bottom:8px;"></div>
          <div class="c4-skeleton" style="height:13px;width:75%;margin-bottom:8px;"></div>
          <div class="c4-skeleton" style="height:15px;width:35%;"></div>
        </div>
      </article>
    `).join('');
  },
};

/* ── Init ─────────────────────────────── */
document.addEventListener('DOMContentLoaded', () => {
  MMC4.CartDrawer.init();
  MMC4.QuickAdd.init();
  MMC4.CompleteLook.init();
  MMC4.SizeGuide.init();
  MMC4.SwatchSwap.init();
  MMC4.PDPGallery.init();
  MMC4.PDPVariants.init();
  MMC4.InfiniteScroll.init();
  MMC4.ClipsFeed.init();
  MMC4.Carousels.init();
  MMC4.MobileMenu.init();
  MMC4.Wishlist.init();
  MMC4.FilterChips.init();
  MMC4.Newsletter.init();
  MMC4.initToast();
  MMC4.HomeVideoGrid.init();
  MMC4.InlineSizePicker.init();
  MMC4.HomePLP.init();
});
